import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = {
  key: 0,
  class: "caption-top visually-hidden"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "me-2" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = ["colspan"]

import { ref } from 'vue';
import { BTableColumn, BTableOptions } from "./BTable.types";


export default /*@__PURE__*/_defineComponent({
  __name: 'BTable',
  props: {
    items: { default: () => [] },
    columns: { default: () => [] as BTableColumn[] },
    showHeader: { type: Boolean, default: true },
    value: { default: () => ({
        totalItemCount: 0,
        itemsPerPage: 1,
        page: 1,
        sortBy: []
    }) as BTableOptions },
    caption: { default: "" },
    tableStyle: { default: "" }
  },
  emits: ['optionChange'],
  setup(__props: any, { emit: __emit }) {


const props = __props;

var tableOptions = ref(props.value as BTableOptions);

const emit = __emit;
function isAscending(column: BTableColumn): boolean {
    var s = tableOptions.value.sortBy[0];
    return s && s.key == column.key && !s.isDescending;
}

function isDescending(column: BTableColumn): boolean {
    var s = tableOptions.value.sortBy[0];
    return s && s.key == column.key && s.isDescending;
}

function onColumnClick(column: BTableColumn) {
    var s = tableOptions.value.sortBy[0];

    if (s && s.key == column.key) {
        if (s.isDescending) {
            tableOptions.value.sortBy = [];
        } else {
            tableOptions.value.sortBy[0].isDescending = true;
        }
    } else {
        tableOptions.value.sortBy = [
            {
                key: column.key,
                isDescending: false
            }
        ];
    }
    tableOptions.value.page = 1;

    emit("optionChange", tableOptions.value);
}


return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", {
      class: "table table-light table-striped",
      style: _normalizeStyle(_ctx.tableStyle)
    }, [
      (_ctx.caption != '')
        ? (_openBlock(), _createElementBlock("caption", _hoisted_2, _toDisplayString(_ctx.caption), 1))
        : _createCommentVNode("", true),
      (_ctx.showHeader)
        ? (_openBlock(), _createElementBlock("thead", _hoisted_3, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: column.key,
                  style: _normalizeStyle(column.columnStyle || {}),
                  class: _normalizeClass(column.columnClass || [])
                }, [
                  _renderSlot(_ctx.$slots, `header.${column.key}`, { column: column }, () => [
                    _createElementVNode("div", _hoisted_4, [
                      (column.sortable)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            onClick: _withModifiers(($event: any) => (onColumnClick(column)), ["prevent"]),
                            href: "",
                            class: "link-dark"
                          }, _toDisplayString(column.text), 9, _hoisted_5))
                        : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(column.text), 1)),
                      _withDirectives(_createElementVNode("i", {
                        class: _normalizeClass(["bi bi-arrow-up position-absolute", isAscending(column) ? '' :'invisible'])
                      }, null, 2), [
                        [_directive_tooltip, 'Sorted asc']
                      ]),
                      _withDirectives(_createElementVNode("i", {
                        class: _normalizeClass(["bi bi-arrow-down position-absolute", isDescending(column) ? '' :'invisible'])
                      }, null, 2), [
                        [_directive_tooltip, 'Sorted desc']
                      ])
                    ])
                  ]),
                  _renderSlot(_ctx.$slots, `header.bottom.${column.key}`, { column: column })
                ], 6))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.items != null && _ctx.items.length > 0)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.id
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: column.key,
                    style: _normalizeStyle(column.style ? column.style(item) : {}),
                    class: _normalizeClass([column != undefined && column.class != undefined ? column.class(item) : [], "align-middle"])
                  }, [
                    _renderSlot(_ctx.$slots, `cell.${column.key}`, {
                      column: column,
                      item: item
                    }, () => [
                      _createTextVNode(_toDisplayString(column.value ?
                            column.value(item) : item), 1)
                    ])
                  ], 6))
                }), 128))
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", {
                colspan: _ctx.columns.length
              }, "No data to display at this time", 8, _hoisted_9)
            ])
          ]))
    ], 4)
  ]))
}
}

})